// src/Protect.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from './stores/authStore';  // ← 追加

export default function Protect({ children, allowTypes }) {
  const location = useLocation();
  const { accessToken, userType, logout } = useAuthStore();  // ← 変更

  const roleOk =
    !Array.isArray(allowTypes) ||
    allowTypes.length === 0 ||
    allowTypes.includes(userType);

  const ok = !!accessToken && roleOk;

  if (!ok) {
    logout();  // ← 変更: sessionStorage.clear() から変更
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}